<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Empresas">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>                  
              
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)" v-show="$store.state.currentUser.id == 1 || $store.state.currentUser.id == 100"><i class="fa fa-plus"></i><span>Nova Empresa</span></b-button>
                </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
          
                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(name)="data">
                    <span class="text-brand-500" color="gray">{{ data.item.doc }}</span><br>
                    <span class="text-dark font-weight-bold">{{ data.item.name }}</span>
               
                </template>
                

            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  


     <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Empresa"
            size="lg">

        <b-card>
          <b-form @submit.stop.prevent="onSubmit">

          <div class="animated fadeIn">
        
            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description="Código único da empresa"
                  label="Código"
                  label-for="id"
                  :label-cols="3"
                  :horizontal="true">
                  <b-row>
                    <b-col sm="4">
                      <b-form-input v-model="selectedItem.id" id="id" type="text"></b-form-input>
                    </b-col>
                  </b-row>
                  
                </b-form-group>          
                </b-form>
                </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form>
                  <b-form-group
                  description=""
                  label="Nome de exibição"
                  label-for="code"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input v-model="selectedItem.alias" id="alias" type="text"></b-form-input>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Empresa"
                  label-for="name"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input v-model="selectedItem.name" id="name" type="text"></b-form-input>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="CPF/CNPJ"
                  label-for="doc"
                  :label-cols="3"
                  :horizontal="true">
                  <b-input-group  style="width: 300px">
                      <b-input-group-append><b-input-group-text><i class="fa fa-id-card"></i></b-input-group-text></b-input-group-append>
                      <masked-input
                              type="text"
                              name="doc"
                              class="form-control cols-md-2"
                              v-model="selectedItem.doc"
                              :mask="selectedItem && selectedItem.doc && selectedItem.doc.length > 14 ? [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/] : [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
                              :guide="false"
                              placeholderChar="#"
                              >
                            </masked-input>
                  </b-input-group>
                </b-form-group>          
                </b-form>
              
              </b-col>
            </b-row>
           
            <b-row>
              <b-col md="12">
                <b-form>
                  <b-form-group
                  description=""
                  label="Cidade"
                  label-for="city"
                  :label-cols="3"
                  :horizontal="true">
                  <ddl-city-component 
                    :countryId="this.selectedCountry"
                    :stateId="this.selectedState"
                    :currentCityId="this.selectedCity"
                    @city-selected="handleSelectedCity"
                  ></ddl-city-component>
                  
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form>
                  <b-form-group
                  description=""
                  label="Estado"
                  label-for="state"
                  :label-cols="3"
                  :horizontal="true">
                  <ddl-state-component 
                    :countryId="this.selectedCountry"
                    :currentStateId="this.selectedState"
                    @state-selected="handleSelectedState"
                  ></ddl-state-component>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Conta de e-mail padrão"
                label-for="mailAccount"
                :label-cols="3"
                :horizontal="true">
                <ddl-mail-account-component 
                  :companyId="this.selectedItem.id"
                  :currentMailAccountId="this.selectedMailAccount"
                  @item-selected="handleSelectedMailAccount"
                ></ddl-mail-account-component>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          
          <hr>

          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description="Caso o aplicativo móvel sincronize dados sem especificar uma empresa (CID), apenas empresas com esse item HABILITADO serão enviados para o dispositivo."
                label="Aplicativo móvel"
                label-for="app"
                :label-cols="3"
                :horizontal="true">

                <input id="app" type="checkbox" value="" v-model="selectedItem.app"> Sincroniza dados com aplicativo móvel
              </b-form-group>  

              </b-form>
            </b-col>
          </b-row>

          
            <b-input-group class="mb-4">
                <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
            </b-input-group>
                  
          </div>
          </b-form>

            <div slot="footer" class="text-right">
              <!--
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
              <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
              -->
              <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Empresa</span></b-button>
            
            </div>

        </b-card>

    </b-modal>
    
  
    </div>
  
  </template>
  
  <script>

  import DdlCityComponent from '../../components/DdlCityComponent'
  import DdlStateComponent from '../../components/DdlStateComponent'
  import DdlMailAccountComponent from '../../components/DdlMailAccountComponent.vue';

  import Vue from 'vue'
  import axios from "axios";
  import MaskedInput from 'vue-text-mask'
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      MaskedInput,
      DdlCityComponent,
      DdlStateComponent,
      DdlMailAccountComponent
    },
    data: () => {
      return {


        selectedState: null,
        selectedCountry: null,
        selectedCity: null,
        selectedMailAccount: null,

        stateDDL: [],
        cityDDL: [],
  
        editModal: false,
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        filters: {
          key: ''
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [
          {id: 1, st: 'A', name: 'Brasil', code: 'br', phonecode: "55", _rowVariant: 'none'},
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "100px" } },
          {key: 'id', label: 'Código', sortable: true, thStyle: { width: "80px" }, class: 'text-center' },
          {key: 'alias', label: 'Nome', sortable: true },
          {key: 'name', label: 'Empresa', sortable: true },
          {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }      
        ],
        /*
        fields: [
            'show_details',
            { key: 'first_name', sortable: true }, 
            { key: 'last_name', sortable: true }
        ],
        items: [
          { isActive: true, age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { isActive: false, age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { isActive: false, age: 89, first_name: 'Geneva', last_name: 'Wilson', _showDetails: false },
          { isActive: true, age: 38, first_name: 'Jami', last_name: 'Carney' }
        ],
        */
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return this.filters.key == '' || item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {
     
      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },

      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     
      async saveItem(currentItem) {
        
        var s = this;
        var postData = {...currentItem};

        postData["countryId"] = this.selectedCountry
        postData["stateId"] = this.selectedState
        postData["cityId"] = this.selectedCity
        postData["mailAccountId"] = this.selectedMailAccount
        postData["uid"] = this.$store.state.currentUser.id
        postData["sid"] = this.$store.state.currentUser.sid

        await axios.post(
            this.$store.state.ws_url + "/company",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }).catch(function (error) {
            console.log(error);

            toast ({
                type: VueNotifications.types.warn,
                title: 'Error',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });
        
      },

      save() {

        let msgError = [];

        if(this.selectedItem.alias.length <= 2)
            msgError.push("Nome de exibição");

        if(this.selectedItem.name.length <= 2)
            msgError.push("Empresa");
        
        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

            toast ({
                type: VueNotifications.types.error,
                title: 'Campos Obrigatórios',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
      },

      enableDisable() {
        console.log('Habilitando/desabilitando país')
        console.log(this.selectedItem);
      },
      onRowSelected(items) {
        this.selected = items
      },

      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
        if(!this.tableSelectable) {
            this.clearSelectedRows();
          
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },
     
      handleSelectedCity(cityId) {
        this.selectedItem.cityId = cityId
        this.selectedCity = cityId.toString()
      },

      handleSelectedState(stateId) {
        this.selectedItem.stateId = stateId
        this.selectedState = stateId.toString()        
      },

      handleSelectedMailAccount(mailAccountId) {
        this.selectedItem.mailAccountId = mailAccountId
        this.selectedMailAccount = mailAccountId.toString()        
      },

      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = { ...newItem }

            this.selectedCountry = this.$store.state.config.countryId.toString()
            this.selectedCity = this.$store.state.config.cityId.toString()
            this.selectedState = this.$store.state.config.stateId.toString()
            this.selectedMailAccount = null;
        }
        else {
            this.selectedItem = { ...item }
            
            if(this.selectedItem) {
              this.selectedCountry = this.selectedItem.countryId.toString()
              this.selectedCity = this.selectedItem.cityId.toString()
              this.selectedState = this.selectedItem.stateId.toString()
              this.selectedMailAccount = this.selectedItem.mailAccountId ? this.selectedItem.mailAccountId.toString() : null;
            }
        }
        this.editModal = true;
      },
      
      async refreshData() {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          await axios.get(
              this.$store.state.ws_url + "/company?uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.items = resp.data.obj;
          }).catch(function(error) {
            console.log(error)
          })
          this.isBusy = false;
      }
    },
    mounted: function() {
      this.isBusy = true;
      this.refreshData();
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>